module.exports = __webpack_public_path__ + "assets/ab8b97e4bc5b58d408e1ef75f9a36bcd.mp3";